<template>
	<div class="col-xl-5">
		<div class="card">
			<div class="card-body">
				<ul class="list-group list-group-flush">
					<li class="list-group-item">
						<h5>Información personal alumno</h5>
						<div class="media-body">
							<label>Rut: {{ infoAlumno.numeroDocumento }}</label
							><br />
							<label
								>Nombre: {{ infoAlumno.nombre }}
								{{ infoAlumno.apellido }}</label
							><br />
							<label>Email: {{ infoAlumno.email }}</label>
						</div>
					</li>
				</ul>

				<ul class="list-group list-group-flush">
					<li class="list-group-item">
						<div class="media-body">
							<b-alert v-if="!jsonEstadoNota" show variant="warning"
								>Este alumno ha sufrido un cambio en sus respuestas, es
								necesario un recálculo en su nota final.</b-alert
							>
							<h5>Detalles evaluación</h5>
							<table class="table table-striped table-hover border">
								<tbody>
									<tr>
										<td>Fecha Inicio</td>
										<td>{{ jsonEvaluacionAlumno.fechaHabilitacion }}</td>
									</tr>
									<tr>
										<td>Fecha Cierre</td>
										<td>{{ jsonEvaluacionAlumno.fechaCierre }}</td>
									</tr>
									<tr>
										<td>Cantidad Preguntas</td>
										<td>{{ jsonEvaluacionAlumno.totalPregunta }}</td>
									</tr>
									<tr>
										<td>Preguntas Correctas</td>
										<td>{{ jsonEvaluacionAlumno.respuestasCorrectas }}</td>
									</tr>
									<tr>
										<td>Preguntas Incorrectas</td>
										<td>{{ jsonEvaluacionAlumno.respuestasIncorrectas }}</td>
									</tr>
									<tr>
										<td>Nota Final</td>
										<td>
											{{ precise_round(jsonEvaluacionAlumno.notafinal, 1) }}
										</td>
									</tr>
								</tbody>
							</table>
							<!--  <b-button block variant="primary">Reinicio Control</b-button> -->
						</div>
					</li>
				</ul>

				<div v-if="this.jsonCoordinadora.recalculoNota">
					<b-button
						v-if="jsonEvaluacionAlumno.preguntasRespondidas > 0"
						block
						v-b-modal.modal-recalculoNota
						@click="modalRecalculoNota()"
						variant="primary"
					>
						Recalcular Nota
					</b-button>
				</div>
				<b-alert 
					style="margin-top:2%"
					v-else :show="true" fade variant="warning">
					No tienes los privilegios para recalcular notas.
				</b-alert>

			</div>
		</div>
		<fechaComponent ref="fechaComponent" />
		<recalculoNota ref="recalculoNota" />
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import fechaComponent from "@/components/fechaConversionComponent";
import recalculoNota from "@/components/evaluacion/evaluacion-alumno/modal/recalculoNota";
export default {
	components: {
		fechaComponent,
		recalculoNota
	},
	data() {
		return {
			infoAlumno: "",
			evaluacionAlumno: ""
		};
	},
	computed: {
		...mapState("evaluacionAlumno", ["jsonEvaluacionAlumno"]),
		...mapState("evaluacion", ["jsonEstadoNota"]),
		...mapState('alumno',['jsonCoordinadora'])
	},
	methods: {
		modalRecalculoNota() {
			const datosAlumno = {
				infoAlumno: this.infoAlumno,
				idEvaluacion: this.idEvaluacion
			};
			this.$refs.recalculoNota.getInfoModal(datosAlumno);
		},
		getInfoAlumno(idAlumno) {
			this.axios
				.get("api/getIdAlumno/" + idAlumno)
				.then(res => {
					this.infoAlumno = res.data.alumno;
				})
				.catch(err => console.log(err));
		},
		fecha(fechaCurso) {
			if (fechaCurso) {
				return this.$refs.fechaComponent.fechaFinal(fechaCurso);
			} else {
				return "-";
			}
		},
		precise_round(num, decimals) {
			var t = Math.pow(10, decimals);
			return (
				Math.round(
					num * t +
						(decimals > 0 ? 1 : 0) *
							(Math.sign(num) * (10 / Math.pow(100, decimals)))
				) / t
			).toFixed(decimals);
		}
	},
	created() {
		this.idAlumno = this.$route.params.idAlumno;
		this.idEvaluacion = this.$route.params.idEvaluacion;
		this.getInfoAlumno(this.idAlumno);
	}
};
</script>
